module.exports = __webpack_public_path__ + "img/roles.53d516be.svg";